import { formatMetric } from '../panelConfig';

/**
 * Badge de variación vs período de comparación. `better` marca la dirección
 * favorable: 'up' (revenue, ROAS…), 'down' (CPL, CAC) o 'neutral' (inversión,
 * sin juicio de valor). Sin dato previo (o previo 0) → no se muestra.
 */
function DeltaBadge({ value, previousValue, better }) {
  if (value == null || previousValue == null || !previousValue) return null;
  const delta = (value - previousValue) / previousValue;
  const up = delta >= 0;
  const favorable = better === 'neutral' ? null : (better === 'up') === up;
  const cls =
    favorable === null
      ? 'bg-gray-100 text-gray-500'
      : favorable
        ? 'bg-emerald-50 text-emerald-700'
        : 'bg-red-50 text-red-700';
  const pct = Math.abs(delta * 100).toLocaleString('es-UY', { maximumFractionDigits: 1 });
  return (
    <span className={`mt-2 inline-flex items-center gap-1 self-start rounded-md px-1.5 py-0.5 text-xs font-medium ${cls}`}>
      <span aria-hidden="true">{up ? '▲' : '▼'}</span>
      {up ? '+' : '−'}{pct}%
    </span>
  );
}

export default function MetricCard({ label, value, format, previousValue, better = 'up' }) {
  return (
    <div className="flex flex-col rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-gray-900">{formatMetric(value, format)}</p>
      {previousValue !== undefined && (
        <DeltaBadge value={value} previousValue={previousValue} better={better} />
      )}
    </div>
  );
}
